import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NeighborhoodService } from '../../../../services/neighborhood.service';
import { ChargesCycleService } from '../../../../services/charges-cycle.service';
import { ChargesCycle } from '../../../../models/charges-cycle.model';
import { ChargeCycleModalComponent } from '../../../../components/charge-cycle-modal/charge-cycle-modal.component';

@Component({
  selector: 'app-charge-cycles-page',
  templateUrl: './charge-cycles-page.component.html',
  styleUrl: './charge-cycles-page.component.scss'
})
export class ChargeCyclesPageComponent {

  public chargesCycles: ChargesCycle[] = [];

  constructor(
    public neighborhoodService: NeighborhoodService,
    public chargesCycleService: ChargesCycleService,
    private modalService: NgbModal,
  ) {
    if (this.neighborhoodService.currentNeighborhood) {
      this.loadChargesCycles();
    } else {
      this.neighborhoodService.subCurrentNeighborhood.subscribe(() => {
        this.loadChargesCycles();
      });
    }
  }

  /*
   ██████╗ ██╗ ██████╗██╗      ██████╗ ███████╗
  ██╔════╝ ██║██╔════╝██║     ██╔═══██╗██╔════╝
  ██║      ██║██║     ██║     ██║   ██║███████╗
  ██║      ██║██║     ██║     ██║   ██║╚════██║
  ╚██████╗ ██║╚██████╗███████╗╚██████╔╝███████║
   ╚═════╝ ╚═╝ ╚═════╝╚══════╝ ╚═════╝ ╚══════╝

  */
  async loadChargesCycles(): Promise<void> {
    if (!this.neighborhoodService.currentNeighborhood) return;
    await this.chargesCycleService.getAll(
      this.neighborhoodService.currentNeighborhood.neighborhoodId
    );
    this.chargesCycles = this.chargesCycleService.chargesCycles;
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  onCreateCycle(): void {
    const modalRef = this.modalService.open(ChargeCycleModalComponent);
    modalRef.componentInstance.neighborhoodId =
      this.neighborhoodService.currentNeighborhood!.neighborhoodId;

    modalRef.result.then(
      () => { this.loadChargesCycles(); },
      () => {}
    );
  }

  onUpdateCycle(cycle: ChargesCycle): void {
    const modalRef = this.modalService.open(ChargeCycleModalComponent);
    modalRef.componentInstance.neighborhoodId =
      this.neighborhoodService.currentNeighborhood!.neighborhoodId;
    modalRef.componentInstance.chargesCycle = cycle;

    modalRef.result.then(
      () => { this.loadChargesCycles(); },
      () => {}
    );
  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async onDeleteCycle(chargesCycleId: string): Promise<void> {
    const flag = confirm('¿Está seguro que desea eliminar este ciclo de cobro?');
    if (flag) {
      const success = await this.chargesCycleService.delete(
        chargesCycleId,
        this.neighborhoodService.currentNeighborhood!.neighborhoodId
      );
      if (success) {
        this.chargesCycles = this.chargesCycleService.chargesCycles;
      }
    }
  }

}
